import { render, staticRenderFns } from "./SlotsList.vue?vue&type=template&id=4e04628a&scoped=true&lang=pug&"
import script from "./SlotsList.vue?vue&type=script&lang=js&"
export * from "./SlotsList.vue?vue&type=script&lang=js&"
import style0 from "./SlotsList.vue?vue&type=style&index=0&id=4e04628a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e04628a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
